import Img from '../components/Img';
import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const CelluliteTreatments: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Cellulite Treatments in Wrentham, MA | Atomic Tattoo Removal</title>
        <meta
          name="description"
          content="Reduce the appearance of cellulite with advanced, non-invasive treatments at Atomic Tattoo Removal in Wrentham, MA. Book your free consultation today."
        />
        <meta
          name="keywords"
          content="cellulite treatment, cellulite reduction, non-invasive cellulite, Wrentham MA, Atomic Tattoo Removal"
        />
      </Helmet>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', textAlign: 'justify' }}>
        <h1 style={{ color: '#cb4f2e', textAlign: 'center', marginBottom: '20px' }}>
          Cellulite Treatments in Wrentham, MA
        </h1>
        <h2 style={{ color: '#5C96AC', textAlign: 'center', marginBottom: '20px' }}>
          The Non-Invasive Solution to Cellulite and Dimpling
        </h2>       
        <p>
          If you're looking to reduce the appearance of cellulite and achieve smoother, firmer skin, Atomic Tattoo Removal offers advanced, non-invasive treatments designed to target and minimize cellulite. Our experienced team uses proven technology to help you feel more confident in your skin.
        </p>
        <p>
          Cellulite dimpling occurs when fibrotic septa, or bands of connective tissue, pull down on the skin, creating a dimpled appearance. This is often caused by factors such as genetics, hormonal changes, and lifestyle. Our treatments focus on breaking down these fibrotic bands and stimulating collagen production to improve skin texture and elasticity.
        </p>        
        <div style={{ textAlign: 'center', margin: '30px 0' }}>
          <Img
            src="/assets/cellulite-b4-after1.png"
            alt="Cellulite treatment procedure"
            style={{ maxWidth: '100%', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
          />
        </div>
        <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Safe and Effective Cellulite Reduction</h3>
        <p>
          Our treatments use advanced energy-based technology to target the underlying causes of cellulite, breaking down fat deposits and stimulating collagen production. This process helps to smooth and tighten the skin, reducing the dimpled appearance commonly associated with cellulite.
        </p>
        <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Treatment Details</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li>
            <strong>Consultation:</strong> We'll assess your skin and discuss your goals to create a personalized treatment plan.
          </li>
          <li>
            <strong>Treatment Sessions:</strong> Sessions typically last around 20 minutes. The number of treatments varies by individual, but a series of 3 sessions is recommended for the best results.
          </li>
          <li>
            <strong>Aftercare:</strong> We'll provide you with aftercare instructions to maximize your results and promote healthy, smooth skin.
          </li>
        </ul>
        <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Why Choose Atomic Tattoo Removal?</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li>
            <strong>Expertise:</strong> Our team is trained in the latest cellulite reduction techniques and technologies.
          </li>
          <li>
            <strong>Personalized Care:</strong> We tailor every treatment to your unique needs and goals.
          </li>
          <li>
            <strong>Comfort & Safety:</strong> Your comfort and safety are our top priorities throughout the process.
          </li>
        </ul>
        <p style={{ marginTop: '20px' }}>
          Take the first step toward smoother, more confident skin. Schedule your free consultation today to learn more about our cellulite treatment options.
        </p>
      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <Link to="/book-consultation" style={{ textDecoration: 'none' }}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'book_now_click',
                button_location: 'cellulite_treatment_page', 
              });
            }}
            sx={{
              color: '#f0e9d4',
              '&:hover': { color: '#ffffff', backgroundColor: '#cb4f2e' },
            }}
          >
            Schedule Your Free Consultation
          </Button>
        </Link>
      </div>
      </div>
    </>
  );
};

export default CelluliteTreatments;